import { render, staticRenderFns } from "./MedicationAllergiesTemplate.vue?vue&type=template&id=45b29376"
import script from "./MedicationAllergiesTemplate.vue?vue&type=script&lang=js"
export * from "./MedicationAllergiesTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports